module.exports = __webpack_public_path__ + "img/Background-Giclee-2366x901.8d2589d9.jpeg";